import OptimizelyHelper from 'client/GrowthEngineering/OptimizelyHelper';
import store from 'client/store';

function getLandingPageRoute() {
  return OptimizelyHelper.shouldShowHomeAsLandingPage()
    ? '/home'
    : '/users';
}

/**
 * Checking for command runners first prevents the user from loading an
 * invalid route (something other than #/commands). This can happen if
 * they use a cached URL or type something into the address bar. If it
 * isn't prevented here, the api starts throwing 404 errors that the user
 * can't recover from.
 */
export default function commandRunnerGuard(to, from, next, storeInstance = store) {
  const { path } = to;
  const settingsModule = 'SettingsModule';
  const { disableCommandRunner } = storeInstance.state[settingsModule];
  const isCommandRunner = storeInstance.getters[`${settingsModule}/isCommandRunner`];
  let route; // undefined means continue;

  // Don't stop a logout
  if (path.indexOf('/logout') === 0) {
    next();
    return;
  }

  // Command runners are only allowed to see a subset of main panels
  const commandRunnerPageWhiteList = [
    new RegExp('^/account'),
    new RegExp('^/pricing'),
    new RegExp('^/commands'),
    new RegExp('^/commandresults'),
    new RegExp('^/commandqueue'),
    new RegExp('^/commandqueues'),
    new RegExp('^/contactSupport'),
    new RegExp('^/support'),
  ];
  if (isCommandRunner && !commandRunnerPageWhiteList.some(exp => exp.test(path))) {
    route = '/commands';
  }

  // Special redirects for orgs with the command runner functionality disabled.
  if (disableCommandRunner) {
    // If admin is a command runner, log out with disabled command runner flag
    if (isCommandRunner) {
      route = '/logout?ret=disableCommandRunner';
    } else if (path.indexOf('/commands') === 0) {
      // If we're trying to hit the commands page, bounce out to users
      route = getLandingPageRoute();
    }
  }

  next(route);
}
